/* tslint:disable */
/* eslint-disable */
// These are customized versions of the auto-generated queries.ts

import gql from "graphql-tag";
import * as APITypes from "../API";

// Account

export const getAccount = /* GraphQL */ gql`
    query GetAccount($id: ID!) {
        getAccount(id: $id) {
            id
            createdAt
            updatedAt
            ownerId
            name
            address
            city
            state
            postalCode
            users {
                items {
                    id
                    createdAt
                    updatedAt
                    userStatus
                    userType
                    startDate
                    endDate
                    accountId
                    firstName
                    lastName
                    email
                    phone
                    emailVerified
                    phoneVerified
                    mfaPreference
                    role
                    advisorAccess
                    lastAccess
                    customerId
                    currentModelId
                    advisorModelId
                    primaryModelId
                    advisorPrimaryModelId
                    currentPlanId
                    migrateStatus
                    migratedOn
                    subscribedOn
                    cancelledOn
                    deletedOn
                    deletedReason
                    clientOn
                    referrer
                    sessionCount
                }
                nextToken
            }
        }
    }
`;

// User

export const listUsersByAccount = /* GraphQL */ gql`
query ListUsersByAccount(
  $accountId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsersByAccount(
    accountId: $accountId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      userStatus
      userType
      startDate
      endDate
      accountId
      firstName
      lastName
      email
      phone
      emailVerified
      phoneVerified
      mfaPreference
      role
      advisorAccess
      lastAccess
      customerId
      currentModelId
      advisorModelId
      primaryModelId
      advisorPrimaryModelId  
      currentPlanId
      migrateStatus
      migratedOn
      subscribedOn
      cancelledOn
      deletedOn
      deletedReason  
      clientOn
      referrer
      sessionCount
    }
    nextToken
  }
}
`;

export const getUserOnly = /* GraphQL */ gql`
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            createdAt
            updatedAt
            userStatus
            userType
            startDate
            endDate
            accountId
            firstName
            lastName
            email
            phone
            emailVerified
            phoneVerified
            mfaPreference
            role
            advisorAccess
            lastAccess
            customerId
            currentModelId
            advisorModelId
            primaryModelId
            advisorPrimaryModelId
            currentPlanId
            migrateStatus
            migratedOn
            subscribedOn
            cancelledOn
            deletedOn
            deletedReason
            clientOn
            referrer
            sessionCount
        }
    }
`;

export const getUser = /* GraphQL */ gql`
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            createdAt
            updatedAt
            userStatus
            userType
            startDate
            endDate
            accountId
            account {
                id
                createdAt
                updatedAt
                ownerId
                name
                address
                city
                state
                postalCode
            }
            firstName
            lastName
            email
            phone
            emailVerified
            phoneVerified
            mfaPreference
            role
            advisorAccess
            lastAccess
            customerId
            currentModelId
            advisorModelId
            primaryModelId
            advisorPrimaryModelId
            currentPlanId
            models {
                items {
                    id
                    createdAt
                    updatedAt
                    updatedBy
                    accountId
                    userId
                    name
                    description
                    startedAt
                    advisorCreated
                    clientAccess
                    archived
                    settings
                }
                nextToken
            }
            migrateStatus
            migratedOn
            subscribedOn
            cancelledOn
            deletedOn
            deletedReason
            clientOn
            referrer
            sessionCount
            settings {
                items {
                    id
                    createdAt
                    updatedAt
                    userId
                    accountId
                    name
                    description
                    settingType
                    settings
                }
                nextToken
            }
            reviews {
                items {
                    id
                    createdAt
                    updatedAt
                    userId
                    accountId
                    modelId
                    snapshotId
                    baseSnapId
                    reviewDate
                    checklist
                    submittedOn
                    managed
                    archived
                    status
                }
                nextToken
            }
        }
    }
`;

// UserSetting

export const getUserSetting = /* GraphQL */ gql`query GetUserSetting($id: ID!) {
    getUserSetting(id: $id) {
        id
        createdAt
        updatedAt
        userId
        accountId
        name
        description
        settingType
        settings
    }
}
`;

// UserInvite

export const getUserInvite = /* GraphQL */ gql`query GetUserInvite($id: ID!) {
    getUserInvite(id: $id) {
        id
        createdAt
        updatedAt
        accountId
        userId
        firstName
        lastName
        email
        role
        invitedOn
    }
}
`;

export const listUserInvites = /* GraphQL */ gql`query ListUserInvites(
    $id: ID
    $filter: ModelUserInviteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
) {
    listUserInvites(
        id: $id
        filter: $filter
        limit: $limit
        nextToken: $nextToken
        sortDirection: $sortDirection
    ) {
        items {
            id
            createdAt
            updatedAt
            accountId
            userId
            firstName
            lastName
            email
            role
            invitedOn
        }
        nextToken
    }
}
`;

export const listUserInvitesByAccount = /* GraphQL */ gql`query ListUserInvitesByAccount(
    $accountId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserInviteFilterInput
    $limit: Int
    $nextToken: String
) {
    listUserInvitesByAccount(
        accountId: $accountId
        sortDirection: $sortDirection
        filter: $filter
        limit: $limit
        nextToken: $nextToken
    ) {
        items {
            id
            createdAt
            updatedAt
            accountId
            userId
            firstName
            lastName
            email
            role
            invitedOn
            __typename
        }
        nextToken
        __typename
    }
}
`;

// Person

export const getPerson = /* GraphQL */ gql`
    query GetPerson($id: ID!) {
        getPerson(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            nickname
            gender
            maritalStatus
            birthDate
            hereditaryAdjust
            lifeExpectancy
            retireDate
            state
        }
    }
`;

// Model

export const listModelsByUser = /* GraphQL */ gql`
query ListModelsByUser(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelModelFilterInput
  $limit: Int
  $nextToken: String
) {
  listModelsByUser(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      updatedBy
      accountId
      userId
      name
      description
      startedAt
      advisorCreated
      clientAccess
      archived
      settings
    }
    nextToken
  }
}
`;

export const getModel = /* GraphQL */ gql`
    query GetModel($id: ID!) {
        getModel(id: $id) {
            id
            createdAt
            updatedAt
            updatedBy
            accountId
            userId
            name
            description
            startedAt
            advisorCreated
            clientAccess
            archived
            settings
            persons {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    nickname
                    gender
                    maritalStatus
                    birthDate
                    hereditaryAdjust
                    lifeExpectancy
                    retireDate
                    state
                }
                nextToken
            }
            assets {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    assetCategory
                    assetType
                    description
                    risk
                    balance
                    balanceDate
                    returnRate
                    rateLock
                    withdrawalOrder
                    inheritedYear
                    originalOwnerBirthYear
                    start
                    end
                    startDate
                    endDate
                    sortOrder
                    ownerId
                    priorEoYBalance
                    withdrawalsYTD
                    managed
                    archived
                }
                nextToken
            }
            assetConversions {
                items {
                    id
                    createdAt
                    updatedAt
                    userId
                    accountId
                    modelId
                    description
                    conversionType
                    srcAssetId
                    dstAssetId
                    year
                    amount
                    percent
                    sortOrder
                    completedAt
                    taxableAmount
                    nonTaxableAmount
                    incomeType
                    archived
                }
                nextToken
            }
            liabilities {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    description
                    balance
                    balanceDate
                    start
                    end
                    startDate
                    payoffDate
                    interestRate
                    ownerId
                    sortOrder
                    archived
                }
                nextToken
            }
            snapshots {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    date
                    description
                    snapshotType
                    archived
                    details
                }
                nextToken
            }
            incomes {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    incomeType
                    description
                    amount
                    amountDate
                    schedule
                    infLock
                    annualInf
                    start
                    end
                    startDate
                    endDate
                    sortOrder
                    ownerId
                    survivorPercent
                    archived
                }
                nextToken
            }
            deductions {
            items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    amount
                    amountDate
                    schedule
                    infLock
                    annualInf
                    start
                    end
                    startDate
                    endDate
                    description
                    sortOrder
                    assetId
                    archived
                }
                nextToken
            }
            taxes {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    taxType
                    description
                    amount
                    amountDate
                    schedule
                    infLock
                    annualInf
                    start
                    end
                    startDate
                    endDate
                    sortOrder
                    ownerId
                    archived
                }
                nextToken
            }
            expenses {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    expenseCategory
                    description
                    amount
                    amountDate
                    schedule
                    infLock
                    annualInf
                    start
                    end
                    startDate
                    endDate
                    discretionary
                    assetId
                    liabilityId
                    sortOrder
                    ownerId
                    archived
                }
                nextToken
            }
            taxValues {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    year
                    key
                    value
                }
                nextToken
            }
            plans {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    userId
                    modelId
                    name
                    description
                    default
                    archived
                    changes {
                        items {
                            id
                            createdAt
                            updatedAt
                            accountId
                            userId
                            modelId
                            planId
                            changeType
                            name
                            description
                            enabled
                            details
                            __typename
                        }
                        nextToken
                    }
                }
                nextToken
            }

        }
    }
`;

// Snapshot

export const getSnapshot = /* GraphQL */ gql`
    query GetSnapshot($id: ID!) {
        getSnapshot(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            date
            description
            snapshotType
            archived
            details
        }
    }
`;
export const listSnapshots = /* GraphQL */ gql`
    query ListSnapshots(
        $id: ID
        $filter: ModelSnapshotFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listSnapshots(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                createdAt
                updatedAt
                accountId
                userId
                modelId
                date
                description
                snapshotType
                archived
                details
            }
            nextToken
        }
    }
`;

export const listSnapshotsByModel = /* GraphQL */ gql`
    query ListSnapshotsByModel(
        $modelId: ID!
        $date: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelSnapshotFilterInput
        $limit: Int
        $nextToken: String
    ) {
        listSnapshotsByModel(
            modelId: $modelId
            date: $date
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                createdAt
                updatedAt
                accountId
                userId
                modelId
                date
                description
                snapshotType
                archived
                details
            }
            nextToken
        }
    }
`;

// Asset

export const getAsset = /* GraphQL */ gql`
    query GetAsset($id: ID!) {
        getAsset(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            assetCategory
            assetType
            description
            risk
            balance
            balanceDate
            returnRate
            rateLock
            withdrawalOrder
            inheritedYear
            originalOwnerBirthYear
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            priorEoYBalance
            withdrawalsYTD
            managed
            archived
        }
    }
`;

// AssetConversion

export const getAssetConversion = /* GraphQL */ gql`
query GetAssetConversion($id: ID!) {
  getAssetConversion(id: $id) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    description
    conversionType
    srcAssetId
    dstAssetId
    year
    amount
    percent  
    sortOrder
    completedAt
    taxableAmount
    nonTaxableAmount
    incomeType
    archived
  }
}
`;

// Liability

export const getLiability = /* GraphQL */ gql`
    query GetLiability($id: ID!) {
        getLiability(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            description
            balance
            balanceDate
            start
            end
            startDate
            payoffDate
            interestRate
            ownerId
            sortOrder
            archived
        }
    }
`;

// Income

export const getIncome = /* GraphQL */ gql`
    query GetIncome($id: ID!) {
        getIncome(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            incomeType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            survivorPercent
            archived
        }
    }
`;

// Deduction

export const getDeduction = /* GraphQL */ gql`
    query GetDeduction($id: ID!) {
        getDeduction(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            description
            sortOrder
            assetId
            archived
        }
    }
`;

// Tax

export const getTax = /* GraphQL */ gql`
    query GetTax($id: ID!) {
        getTax(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            taxType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            archived
        }
    }
`;

// Expense

export const getExpense = /* GraphQL */ gql`
    query GetExpense($id: ID!) {
        getExpense(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            expenseCategory
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            discretionary
            assetId
            liabilityId
            sortOrder
            ownerId
            archived
        }
    }
`;

// TaxValues

export const getTaxValue = /* GraphQL */ gql`
    query GetTaxValue($id: ID!) {
    getTaxValue(id: $id) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            year
            key
            value
        }
    }
`;

// Plan

export const listPlansByModel = /* GraphQL */ gql`query ListPlansByModel(
  $modelId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlansByModel(
    modelId: $modelId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      userId
      accountId
      modelId
      name
      description
      enabled
      default
      archived
    }
    nextToken
  }
}
`;

export const getPlan = /* GraphQL */ gql`
query GetPlan($id: ID!) {
  getPlan(id: $id) {
    id
    createdAt
    updatedAt
    accountId
    userId
    modelId
    name  
    description
    default
    archived
    changes {
      items {
          id
          createdAt
          updatedAt
          accountId
          userId
          modelId
          planId
          changeType
          name
          description
          enabled
          details
      }
      nextToken
    }
  }
}
`;

// PlanChange

export const getPlanChange = /* GraphQL */ gql`
query GetPlanChange($id: ID!) {
    getPlanChange(id: $id) {
        id
        createdAt
        updatedAt
        accountId
        userId
        modelId
        planId
        changeType
        name
        description
        enabled
        details
    }
}
`;

// Review

export const getReview = /* GraphQL */ gql`query GetReview($id: ID!) {
  getReview(id: $id) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    snapshotId
    baseSnapId
    reviewDate
    checklist
    submittedOn
    managed
    archived
    status  
  }
}
`;

export const listReviewsByUser = /* GraphQL */ gql`query ListReviewsByUser(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelReviewFilterInput
  $limit: Int
  $nextToken: String
) {
  listReviewsByUser(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      userId
      accountId
      modelId
      snapshotId
      baseSnapId  
      reviewDate
      checklist
      submittedOn
      managed
      archived  
      status  
    }
    nextToken
  }
}`;

// Session

export const getSession = /* GraphQL */ gql`query GetSession($id: ID!) {
    getSession(id: $id) {
        id
        createdAt
        updatedAt
        accountId
        userId
        sessionDate
        duration
        __typename
    }
}`;

export const listSessions = /* GraphQL */ gql`query ListSessions(
    $id: ID
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
) {
    listSessions(
        id: $id
        filter: $filter
        limit: $limit
        nextToken: $nextToken
        sortDirection: $sortDirection
    ) {
        items {
            id
            createdAt
            updatedAt
            accountId
            userId
            sessionDate
            duration
            __typename
        }
        nextToken
        __typename
    }
}`;

export const listSessionsByUser = /* GraphQL */ gql`query ListSessionsByUser(
    $userId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
) {
    listSessionsByUser(
        userId: $userId
        date: $date
        sortDirection: $sortDirection
        filter: $filter
        limit: $limit
        nextToken: $nextToken
    ) {
        items {
            id
            createdAt
            updatedAt
            accountId
            userId
            sessionDate
            duration
            __typename
        }
        nextToken
        __typename
    }
}`;